import * as React from 'react'
import { FunctionComponent } from 'react'
import TableContext, {
  createTableContext,
} from '../../../../contexts/TableContext'
import { ReportGroupBy } from '../../../../typings/report'
import ApplicationsTable from './ApplicationsTable'

type ApplicationsSorts =
  | 'clickDate'
  | 'productId'
  | 'productName'
  | 'applicationDate'

type GroupBy = { [key in ReportGroupBy]: string }

interface ApplicationsFilters extends GroupBy {
  groupBy: string
  dateType: string
  startDate: string
  endDate: string
}

export const ApplicationsTableContext = createTableContext<
  ApplicationsFilters,
  ApplicationsSorts
>()

const ApplicationsReport: FunctionComponent = () => {
  return (
    <TableContext<ApplicationsFilters, ApplicationsSorts>
      Context={ApplicationsTableContext}
      queryParams={[
        'dateType',
        'endDate',
        'startDate',
        'productType',
        'product',
        'category',
        'advertiser',
        'subtracking',
      ]}
    >
      <ApplicationsTable />
    </TableContext>
  )
}

export default ApplicationsReport
